module.exports = __webpack_public_path__ + "img/header_people.891cdc30.png";